import { AbstractControl, ValidationErrors } from '@angular/forms';

export function urlSyntaxValidator(control: AbstractControl): ValidationErrors | null {
  if (!control.value) return null;
  const urlPattern = /^https?:\/\/([\w-]+\.)+[\w-]{2,}(\/\S*)?$/i;

  return urlPattern.test(control.value) ? null : { invalidSyntaxUrl: true };
}
